import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import ReservationActions, { reservationActionTypes } from '@Actions/reservationActions';
import ReservationServices from '@Services/reservationServices';

/**
 *
 * @param {*} action
 */
function* _createReservation(action) {
  const { payload, callback } = action;
  try {
    yield put(ReservationActions.createReservationLoading(true));
    const newGst = yield ReservationServices.createReservation(payload);
    if (newGst.success) {
      yield put(TrackerActions.trackAction(reservationActionTypes.CREATE_RESERVATION.SUCCESS, {
        request: action?.payload,
        response: newGst,
      }));
      notification.open({
        type: 'success',
        message: 'This Batch is reserved successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: newGst.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ReservationActions.createReservationLoading(false));
  } catch (error) {
    yield put(ReservationActions.createReservationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reservationActionTypes.CREATE_RESERVATION.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createReservation() {
  yield takeLatest(reservationActionTypes.CREATE_RESERVATION.REQUEST, _createReservation);
}

/**
 *
 * @param {*} action
 */
function* _getReservation(action) {
  const { payload, callback } = action;
  try {
    yield put(ReservationActions.getReservationLoading(true));
    const reservation = yield ReservationServices.getReservation(payload?.entityLineType, payload?.entityLineId, payload?.tenantProductId);
    yield put(ReservationActions.getReservationSuccess(reservation));
    if (callback) {
      callback(reservation);
    }
    yield put(ReservationActions.getReservationLoading(false));
  } catch (error) {
    yield put(ReservationActions.getReservationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reservationActionTypes.GET_RESERVATION.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getReservation() {
  yield takeLatest(reservationActionTypes.GET_RESERVATION.REQUEST, _getReservation);
}

/**
 *
 * @param {*} action
 */
function* _updateFreeReservation(action) {
  try {
    yield put(ReservationActions.updateFreeReservationLoading(true));
    const updateFreeReservation = yield ReservationServices.updateFreeReservation(action.payload);
    if (updateFreeReservation.success) {
      yield put(TrackerActions.trackAction(reservationActionTypes.UPDATE_FREE_RESERVATION.SUCCESS, {
        request: action?.payload,
        response: updateFreeReservation,
      }));
      notification.open({
        type: 'success',
        message: 'Batch updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updateFreeReservation.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ReservationActions.updateFreeReservationLoading(false));
  } catch (error) {
    yield put(ReservationActions.updateFreeReservationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reservationActionTypes.UPDATE_FREE_RESERVATION.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* updateFreeReservation() {
  yield takeLatest(reservationActionTypes.UPDATE_FREE_RESERVATION.REQUEST, _updateFreeReservation);
}

/**
 *
 */
export default function* reservationSaga() {
  yield all([createReservation(), getReservation(), updateFreeReservation()]);
}
